export default __webpack_public_path__ + "static/media/outdoor_store_sign_original.430a21ab.jpg";